import { css } from '@huspy/styled-system/css';

const transactionsTableStyles = {
  tableContainer: css({
    width: '100%',
    borderWidth: '1px',
    borderColor: 'border-secondary',
    borderRadius: 'radius-3',
    paddingX: 1,
    paddingY: 3,
  }),
  tableRow: css({
    borderTop: 'none !important',
    borderBottom: 'none !important',
  }),
  iconContainer: css({
    backgroundColor: 'utility-blue-50',
    width: 10,
    height: 10,
    borderRadius: '50%',
  }),
};

export default transactionsTableStyles;
